import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { StudyReportSearchItem } from '../../../model/study-report-search-item';



export class StudyReportSearchItemUnificationDialogRequest {
  public studyReportSearchItemUnificationCandidates: StudyReportSearchItem[];
  public studyReportSearchItem:  StudyReportSearchItem;
}


export class StudyReportSearchItemUnificationDialogResponse {
  constructor(studyReportChildsId: number[], studyReportSearchItem:  StudyReportSearchItem) {
    this.studyReportChildsId = studyReportChildsId;
    this.studyReportSearchItem = studyReportSearchItem;
  }
  public studyReportChildsId: number[];
  public studyReportSearchItem:  StudyReportSearchItem;
}

@Component({
  selector: 'app-study-report-unification-dialog',
  templateUrl: './study-report-unification-dialog.component.html',
  styleUrls: ['./study-report-unification-dialog.component.css']
})
export class StudyReportUnificationDialogComponent {

  columns = ['Select', 'DateTime', 'DeliveryDate', 'Protocol',
             'PatientFullName', 'PracticeName', 'StudyReportRegion'];
  dataSource = new MatTableDataSource([]);
  studyReportSearchItemIds: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<StudyReportUnificationDialogComponent>,
    private notificationToastService: NotificationToastService,
    @Inject(MAT_DIALOG_DATA) public data: StudyReportSearchItemUnificationDialogRequest) {
      this.dataSource = new MatTableDataSource(this.data.studyReportSearchItemUnificationCandidates);
      this.studyReportSearchItemIds = [];
    }

    onNoClick(): void {
      this.dialogRef.close(null);
    }

    unification(): void {
      if ( this.studyReportSearchItemIds.length > 0) {
        this.dialogRef.close(null);
        const response = new StudyReportSearchItemUnificationDialogResponse(this.studyReportSearchItemIds,
          this.data.studyReportSearchItem);
        this.dialogRef.close(response);
      }
    }

    noUnification(): void {
        this.dialogRef.close(null);
        const response = new StudyReportSearchItemUnificationDialogResponse(null,
          this.data.studyReportSearchItem);
        this.dialogRef.close(response);
    }

    checkChange(id: number): void {
      const index = this.studyReportSearchItemIds.findIndex(x => x === id);
      if (index > -1) {
        this.studyReportSearchItemIds.splice(index, 1);
      } else {
        this.studyReportSearchItemIds.push(id);
      }
    }
}

